import { Fragment } from "react"
import { useSelector } from "react-redux"

export default function Success({certificate_type, setPopup}) {

    const CMS = useSelector((state) => state.CMS)

    return (
        <Fragment>
            <div className="text-[1.5rem] font-semibold mb-2">
                {certificate_type?.label}
                {certificate_type?.shortcut === 'award' && '獲獎證明'} 申請完成
            </div>
            <div className="text-[0.875rem] text-black-700 font-light mb-9">
                申請作業已完成，系統作業流程可能需要數分鐘時間。完成後證明文件將寄至指定信箱。如有資料變更的申請，可能會額外花費數天進行審核。如有疑問請聯繫服務信箱 <a className="underline" href={`mailto:${CMS.registries['cms.home.footer.email']}}`}>{CMS.registries['cms.home.footer.email']}</a>。
            </div>
            <button
                type="button"
                className="w-full btn-black btn-round"
                onClick={() => { setPopup(null) }}
            >完成</button>
        </Fragment>
    )
}